import defaultSettings from '@/settings';
var title = window.localStorage.getItem('platSiteName') || '';
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
  return "".concat(title);
}